import { render, staticRenderFns } from "./EditFormView.vue?vue&type=template&id=7db72ca6"
import script from "./EditFormView.vue?vue&type=script&lang=js"
export * from "./EditFormView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports